import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';
import { CompanyBillingRecord } from 'src/features/companyBilling/companyBilling.types';

const headsetBillingApiPath = (id: string) => `companies/${id}/billing/devices`;

export type GetBillingParams = {
  start?: string;
  end?: string;
};

export const getBillingByCompanyId = async ({
  companyId,
  params,
}: {
  companyId: string;
  params?: {
    start?: string;
    end?: string;
  };
}): Promise<AxiosResponse<CompanyBillingRecord[] & ApiError>> => {
  return instance
    .get<CompanyBillingRecord[]>(headsetBillingApiPath(companyId), { params })
    .catch(e => e.response as AxiosError<ApiError> as never);
};
